import React from 'react';

import { useParams } from 'react-router-dom';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import PaidHolidayPatternAddForm from 'components/organismos/master/attend/PaidHolidayPatternAddForm';

const PaidHolidayPatternAddPage: React.FC = () => {
  const {
    paidHolidayPatternId,
  } = useParams();

  return (
    <SidebarTemplate
      pageTitle={paidHolidayPatternId ? '有給パターン編集' : '有給パターン作成'}
    >
      <PaidHolidayPatternAddForm />
    </SidebarTemplate>
  );
};

export default PaidHolidayPatternAddPage;
